import { DomSanitizer, SafeUrl, SafeResourceUrl } from "@angular/platform-browser";
import { Component, OnInit, ViewChild } from '@angular/core';

import { UserModel } from '../../model/user.model';
import { UserService } from '../../service/user.service';
import { AttachmentModel } from '../../model/attachment.model';
import { MessageComponent } from '../message/message.component';
import { AttachmentService } from '../../service/attachment.service';
import { ReturnMessageModel } from '../../model/return-message.model';

@Component({
  selector: 'app-user-signature-modal',
  templateUrl: './user-signature-modal.component.html',
  styles: [`.center { align-content: center; text-align: center; }`]
})
export class UserSignatureModalComponent implements OnInit {
	@ViewChild(MessageComponent) message: MessageComponent;

  display = false;
  showId = false;

  files: any;
  lastEvent: any;
	initialMidia: any;

  user: UserModel = new UserModel();

  uploadPath: string = localStorage.getItem("apiIP") + "/upload";
  
  constructor(
    private attachmentService: AttachmentService,
    private userService: UserService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {}

  lazy(e) {
    this.lastEvent = e;

    if (this.user && this.user.id)
    this.userService.findByPk(this.user.id).subscribe(user => {
      this.user = user as UserModel;
    });
  }

  onShow(user) {
    if(user) {
      this.user = user;
      this.display = true;

      this.lazy(this.lastEvent);
    }
  }

  onHide() {
    this.user = new UserModel();
    this.display = false;
  }

  onSelect(e) {
    this.user.signature_image = e.data as AttachmentModel;
  }

  onNew() {
    this.user.signature_image = new AttachmentModel();
  }

  onSave() {
    this.message.info('saving', 5000);

    // this.user.signature_image.user_id = this.user.id;
    this.user.signature_image.signature_user_id = this.user.id;

    if (this.user.signature_image && this.attachmentService) {
      this.attachmentService.create(this.user.signature_image)
      .subscribe(_ => {
        this.message.clear();
        this.message.success('success_save_message', 5000);

        this.initialMidia = this.user.signature_image;

        this.lazy(this.lastEvent);
      });
    } else {
      console.log('Invalid Attachment');
    }
  }

  onDelete() {
    if (this.user.signature_image && this.user.signature_image.id) {
      this.message.info('status_waiting', 2000);

      this.attachmentService.delete(this.user.signature_image.id).subscribe((r: ReturnMessageModel) => {
        this.message.success('item_deleted', 2000);
        this.user.signature_image = null;
  
        this.lazy(this.lastEvent);
        this.onNew();
      });
    } else {
      this.message.info('some_items_not_deleted', 4000);
    }
  }

	onSelectMidia(e) {
    this.message.info('waiting_save_message', 2000);

		let newFiles = [];
		if (e.files)
			Array.from(e.files).forEach((item: Blob | any, i, arr) => {
				const reader = new FileReader();

				reader.readAsDataURL(item);
				reader.onload = () => {
          const type = item.type.length > 0 ? item.type : item.name.split('.').pop();

					newFiles.push({ type, file_type: type, base64: reader.result, name: item.name, size: item.size });

					if (arr.length - 1 === i) this.files = newFiles;
					if (!this.initialMidia) this.initialMidia = this.user.signature_image;

					this.user.signature_image = this.files[0];

					return;
				};

			});
	}

	onClearMidia(e) {
		this.user.signature_image = this.initialMidia;
		this.files = [];
	}

  getImgContent(signature_image) {
    if (!signature_image) return;

    if (signature_image.base64) {
      return this.getBlobUrl(signature_image);
    }

    if (signature_image.generated_name) {
      return this.getFullPath('user-signature', signature_image);
    }
  }

  getBlobUrl(signature_image): SafeUrl {
    if (!signature_image.base64.includes(',')) return;

    const base64 = signature_image.base64.split(',')[1];
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'image/png' });
    const blobUrl = URL.createObjectURL(blob);

    return this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
  }

  pathResolver = (attachment: AttachmentModel, fileName?: string) => 
  attachment && attachment.generated_name && attachment.generated_name.length ?
  attachment.generated_name.split('.')[0] + '/' + (fileName || attachment.generated_name) : '';

  getFullPath(folder: string, attachment: AttachmentModel) {
    let completePath = '';

    if (attachment) {
      let uploadPath = `${this.uploadPath}/${folder}-attachment/`;

      if (attachment.compressed)
      completePath = uploadPath + this.pathResolver(attachment, 'COMPRESSED.jpg');
      else
      completePath = uploadPath + this.pathResolver(attachment);

      if (attachment.generated_name && attachment.generated_name.includes('home'))
      completePath = '../assets/layout/images/preloader.gif';
    }

    return completePath;
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/component/user-signature-modal/user-signature-modal.component.ts